import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import './App.css';

// Authentication
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';

// New Premium Pages
import LandingPage from './pages/LandingPage';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import DataDeletion from './pages/DataDeletion';
import Contact from './pages/Contact';
import Support from './pages/Support';

// Old Pages (mantidas para compatibilidade)
import PatientList from './pages/PatientList';
import ExamForm from './pages/ExamForm';
import ReportEditor from './pages/ReportEditor';
import Home from './pages/Home';

// Import new functional pages
import Patients from './pages/Patients';
import NewPatient from './pages/NewPatient';
import PatientDetail from './pages/PatientDetail';
import PatientEdit from './pages/PatientEdit';
import PatientEvolution from './pages/PatientEvolution';
import ReportWizard from './pages/ReportWizard';
import Settings from './pages/Settings';
import ExamsList from './pages/ExamsList';
import ExamDetails from './pages/ExamDetails';
import ReportsList from './pages/ReportsList';
import ReportDetail from './pages/ReportDetail';
import EvolutionAnalysis from './pages/EvolutionAnalysis';
import MetricsDashboard from './pages/MetricsDashboard';

function App() {
  return (
    <Router>
      <AuthProvider>
      <Toaster 
        position="top-right"
        reverseOrder={false}
        toastOptions={{
          // Configuração global
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '14px',
            fontWeight: '500',
          },
          // Estilos específicos por tipo
          success: {
            duration: 3000,
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
            style: {
              background: '#10b981',
            },
          },
          error: {
            duration: 5000,
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
            style: {
              background: '#ef4444',
            },
          },
          loading: {
            iconTheme: {
              primary: '#3b82f6',
              secondary: '#fff',
            },
            style: {
              background: '#3b82f6',
            },
          },
        }}
      />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/data-deletion" element={<DataDeletion />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Support />} />
          
          {/* Protected App Routes */}
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/metrics" element={<PrivateRoute><MetricsDashboard /></PrivateRoute>} />
          <Route path="/patients" element={<PrivateRoute><Patients /></PrivateRoute>} />
          <Route path="/patients/new" element={<PrivateRoute><NewPatient /></PrivateRoute>} />
          <Route path="/patients/:id" element={<PrivateRoute><PatientDetail /></PrivateRoute>} />
          <Route path="/patients/:id/edit" element={<PrivateRoute><PatientEdit /></PrivateRoute>} />
          <Route path="/patients/:id/evolution" element={<PrivateRoute><PatientEvolution /></PrivateRoute>} />
          <Route path="/exams" element={<PrivateRoute><ExamsList /></PrivateRoute>} />
          <Route path="/exams/:id" element={<PrivateRoute><ExamDetails /></PrivateRoute>} />
          <Route path="/reports" element={<PrivateRoute><ReportsList /></PrivateRoute>} />
          <Route path="/reports/:id" element={<PrivateRoute><ReportDetail /></PrivateRoute>} />
          <Route path="/reports/:patientId/evolution" element={<PrivateRoute><EvolutionAnalysis /></PrivateRoute>} />
          <Route path="/report-wizard" element={<PrivateRoute><ReportWizard /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          
          {/* Old Routes (mantidas para compatibilidade) - Also Protected */}
          <Route path="/old-home" element={<PrivateRoute><Home /></PrivateRoute>} />
          <Route path="/exam/new" element={<PrivateRoute><ExamForm /></PrivateRoute>} />
          <Route path="/report/:examId" element={<PrivateRoute><ReportEditor /></PrivateRoute>} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
